export default __webpack_public_path__ + "static/media/25.afe8a931.svg";